import angular from 'angular';
import 'angular-drag-and-drop-lists';

import DatapointDisplayListController from './list/list.controller';
import DatapointDisplayObjects from './datapoint.objects';
import DatapointDisplayService from './datapoint.service';
import ConfigService from './../../../api/api.module';

const datapointDisplayModule = angular
	.module('datapointDisplay', ['ui.bootstrap', 'ui.router', 'gettext', 'dndLists', ConfigService])
	.controller('DatapointDisplayListController', DatapointDisplayListController)
	.service('DatapointdisplayObjects', DatapointDisplayObjects)
	.service('DatapointdisplayService', DatapointDisplayService);
export default datapointDisplayModule.name;
